import { Box, Button, Typography } from '@mui/material'
import React, { useState } from 'react'
import BackButton from '../../common/BackButton'
import FundAllocationTable from './FundAllocationTable'
import FundAllocationProjection from './FundAllocationProjection'
import { useAppDispatch, useAppSelector } from '../../../store/reducers/store'
import { useNavigate, useParams } from 'react-router-dom'
import { AUTHENTICATED_ROUTES } from '../../../resources/routes-constants'
import { saveDraft, setShowAllocationError, updatePortfolio } from '../../../store/actions/createPortfolio'
import { useTranslation } from 'react-i18next'

const FundAllocationStep: React.FC = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const { id } = useParams();
    const { t } = useTranslation();

    const portfolio = useAppSelector(state => state.createPortfolio.portfolio);
    const totalProportion = portfolio.funds.reduce((a, b) => a + b.proportion, 0);

    const onConfigure = () => {
        if (totalProportion < 1){
            dispatch(setShowAllocationError(true));
            setTimeout(() => {
                dispatch(setShowAllocationError(false));
            }, 5000);
        }else{
            dispatch(updatePortfolio({ field: 'step', value: 4 }));
            dispatch(saveDraft()).then(() => {
                navigate((id !== undefined ? AUTHENTICATED_ROUTES.PORTFOLIO_EDIT_STEP_ROUTE.replace(":id", id) : AUTHENTICATED_ROUTES.PORTFOLIO_CREATE_STEP_ROUTE).replace(":step", '4'));
            });
        }
    }

    const onSaveDraft = () => {
        dispatch(saveDraft()).then(() => {
            navigate(AUTHENTICATED_ROUTES.PORTFOLIOS_CONFIRM_SAVE_ROUTE.replace(":confirmSave", "saved"));
        })
    }

    // const onCloseError = () => {
    //     setShowError(false);
    // }

    return <Box display={"flex"} flexDirection={"column"} width={"1400px"} gap={"24px"} paddingBottom={"50px"}>
        <Box display={"flex"} width={"100%"} gap={"69px"}>
            <Box display={"flex"} flexDirection={"column"} alignItems={"stretch"} flexGrow={1} flexBasis={"45%"} gap={"32px"}>
                <Box display={"flex"} alignItems={"center"} gap={"24px"}>
                    <BackButton />
                    <Typography fontSize={"24px"} fontWeight={"500"} lineHeight={"29.26px"}>{t('CreatePortfolioFundAllocation')}</Typography>
                </Box>
                <FundAllocationTable />
            </Box>
            <Box flexGrow={1} flexBasis={"45%"}>
                <FundAllocationProjection />
            </Box>
        </Box>
        <Box display={"flex"} width={"100%"} justifyContent={"flex-end"} gap={"16px"}>
            <Button variant='contained' onClick={onConfigure}>{t('CreatePortfolioButtonConfirmNConfigure')}</Button>
            <Button variant='outlined' onClick={onSaveDraft}>{t('CreatePortfolioButtonSaveAsDraft')}</Button>
        </Box>
        {/* {showError && <ConfirmationForm title={t('CreatePorfolioUncompleteAllocationTitle')} content={t('CreatePorfolioUncompleteAllocationText')}
            confirmAction={[{type: 'primary', action: onCloseError, title: t('CreatePorfolioUncompleteAllocationClose')}]} onClose={onCloseError} />} */}
    </Box>
}

export default FundAllocationStep